import React from "react";
import { Trans, useTranslation } from "react-i18next";
import styled, { css } from "styled-components";
import { Alert } from "components/bootstrap";
const DangerRow = styled.tr(
  ({ theme }) => css`
    background-color: ${theme.colors.variant.light.danger};
  `
);
import CommonNotificationSummary from "./CommonNotificationSummary";
import commonStyles from "./LegacyNotificationCommonStyles.css";
const LegacyNotificationSummary = (props) => {
  const { t } = useTranslation("event_notifications");
  const { notification, legacyTypes } = props;
  const configurationValues = notification.config.configuration;
  const callbackType = notification.config.callback_type;
  const typeData = legacyTypes[callbackType];
  let content;
  if (typeData) {
    const typeConfiguration = typeData.configuration;
    content = Object.entries(typeConfiguration).map(([key, value]) => /* @__PURE__ */ React.createElement("tr", { key }, /* @__PURE__ */ React.createElement("td", null, value.human_name), /* @__PURE__ */ React.createElement("td", null, configurationValues[key])));
  } else {
    content = /* @__PURE__ */ React.createElement(DangerRow, null, /* @__PURE__ */ React.createElement("td", null, t("legacy.type")), /* @__PURE__ */ React.createElement("td", null, /* @__PURE__ */ React.createElement(
      Trans,
      {
        t,
        i18nKey: "legacy.unknown_callback_type",
        values: { callbackType },
        components: { code: /* @__PURE__ */ React.createElement("code", null) }
      }
    )));
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, !typeData && /* @__PURE__ */ React.createElement(Alert, { bsStyle: "danger", className: commonStyles.legacyNotificationAlert }, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "legacy.unknown_type",
      values: { title: notification.title || t("legacy.default_title"), callbackType },
      components: { code: /* @__PURE__ */ React.createElement("code", null) }
    }
  )), /* @__PURE__ */ React.createElement(CommonNotificationSummary, { ...props }, /* @__PURE__ */ React.createElement(React.Fragment, null, content)));
};
export default LegacyNotificationSummary;
